<script setup>
import { useRoute } from 'vue-router'
const $route = useRoute()

import navItems from '@/navigation/horizontal'
import { themeConfig } from '@themeConfig'

// Composable
import { useSkins } from '@core/composable/useSkins'
import { useThemeConfig } from '@core/composable/useThemeConfig'
import { HorizontalNavLayout } from '@layouts'

// Components
import Footer from '@/layouts/components/Footer.vue'

import { VNodeRenderer } from '@layouts/components/VNodeRenderer'

const {appRouteTransition} = useThemeConfig()
const {layoutAttrs, injectSkinClasses} = useSkins()


const userData = JSON.parse(localStorage.getItem('userData') || '{}')
const userRole = userData && userData.role ? userData.role : null
const isUserLoggedIn = localStorage.getItem('userData') ? true : false

let showingMenu = ref(false)

// ℹ️ This will inject classes in body tag for accurate styling
injectSkinClasses()
</script>

<template>
  <HorizontalNavLayout
    :nav-items="navItems"
    v-bind="layoutAttrs"
  >
    <!-- 👉 navbar -->
    <template #navbar>
      <div
        class="navbar"
        :class="showingMenu ? 'is-showing-menu' : ''"
      >
        <div class="navbar-main">
          <RouterLink
            :to="!isUserLoggedIn?'/home':'/m'"
            class="d-flex align-center gap-x-3"
            @click="showingMenu = false"
          >
            <VNodeRenderer :nodes="themeConfig.app.logo" />
          </RouterLink>
        </div>
      </div>
    </template>

    <!-- 👉 Pages -->
    <RouterView v-slot="{ Component, route }">
      <Transition
        :name="appRouteTransition"
        mode="out-in"
      >
        <Component
          :is="Component"
          :key="route.path"
        />
      </Transition>
    </RouterView>

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>
  </HorizontalNavLayout>
</template>
